import { Component, OnInit, ViewEncapsulation, input, inject } from '@angular/core';

import { ApWindowService } from '@ap/cdk';
import { ApContentService, ApContentPipe } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApButtonComponent } from '@ap/button';

import content from './error.content.json';
import { ApError } from './error';

/**
 * The error components is meant as a page-wide indicator that something went wrong.
 * It is shown when an `apError` is triggered. It's state depends on the error properties.
 */
@Component({
    selector: 'ap-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApIllustrationComponent, ApButtonComponent, ApContentPipe],
    providers: [ApWindowService]
})
export class ApErrorComponent implements OnInit {
    private readonly contentService = inject(ApContentService);
    private readonly windowService = inject(ApWindowService);

    /**
     * The `ApError` to show
     */
    public readonly apError = input.required<ApError>();

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    protected reload(): void {
        this.windowService.location_reload();
    }
}
